// extracted by mini-css-extract-plugin
module.exports = {"flex":"simpleSpinner_flex__3jGt9","center":"simpleSpinner_center__eRPBi","loader":"simpleSpinner_loader___aEWJ","spin":"simpleSpinner_spin__2M08T"};